module.exports = __webpack_public_path__ + "img/font.7e4f065d.png";